module.exports = __webpack_public_path__ + "static/media/Incheon Port-Logo.18628fb1.png";